'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = require('reselect');

var _reactRedux = require('react-redux');

var _defaultTranslator = require('./default-translator');

var _defaultTranslator2 = _interopRequireDefault(_defaultTranslator);

var _localeReducer = require('./locale-reducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (translations) {
  var mapStateToLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _localeReducer.getLocale;
  var propName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'l';
  var translator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _defaultTranslator2.default;

  var makeTranslator = (0, _reselect.createSelector)(function (locale) {
    return locale;
  }, function (locale) {
    return function (key) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return translator.apply(undefined, [translations, key, locale].concat(args));
    };
  });

  var mapStateToProps = function mapStateToProps(state) {
    return _defineProperty({}, propName, makeTranslator(mapStateToLocale(state)));
  };

  return function (WrappedComponent) {
    return (0, _reactRedux.connect)(mapStateToProps, null, null, { getDisplayName: function getDisplayName(name) {
        return 'Localized(' + name + ')';
      } })(WrappedComponent);
  };
};